import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	timeRange: {
		id: 'eoc-schedule.common.ui.period-item.time-range',
		defaultMessage: '{startHourMinute} - {endHourMinute}',
		description:
			'Period item date range, amount of reserved time. (e.g. "6 AM - 5 PM", "5 PM - 5:45 AM", "< Prev - 8 PM" , "< Prev - Next >)',
	},
	endTimeUnknown: {
		id: 'eoc-schedule.common.ui.period-item.end-time-unknown',
		defaultMessage: 'Next >',
		description: 'Placeholder for future unknown time',
	},
	startTimeUnknown: {
		id: 'eoc-schedule.common.ui.period-item.start-time-unknown',
		defaultMessage: '< Prev',
		description: 'Placeholder for past unknown time',
	},
});
